'use client';

import React from 'react';
import { Container, Flex } from '@skin-seoul/design-system';
import { getLayoutOptions } from '@/utils/layout/layoutFilter';
import './klaviyo.css';
import { usePathname } from 'next/navigation';
const Subscribe = () => {
  const pathname = usePathname();
  const {
    subscribe
  } = getLayoutOptions(pathname);
  if (!subscribe) {
    return null;
  }
  return <Flex alignItems="center" background="generic.100" color="white" justifyContent="center" paddingX={{
    base: 6,
    tablet: 12
  }} width="100%" height="auto" className="newsletter-wrap" data-sentry-element="Flex" data-sentry-component="Subscribe" data-sentry-source-file="Subscribe.tsx">
      <Flex className="klaviyo-form-container" width="100%" maxWidth="1280px" justifyContent="center" alignItems="center" mx="auto" role="region" aria-label="Newsletter signup" data-sentry-element="Flex" data-sentry-source-file="Subscribe.tsx">
        <div className="klaviyo-form-WAH7mP"></div>
      </Flex>
      <Container maxWidth="1280px" width="100%" display="none" data-sentry-element="Container" data-sentry-source-file="Subscribe.tsx"></Container>
    </Flex>;
};
export default Subscribe;